import { BrowserRouter, Route, Switch } from "react-router-dom";

import App from "./components/App";
import Loadable from "react-loadable";
import Loading from "./components/helpers/loading";
import React from "react";
import ReactDOM from "react-dom";
import Root from "./Root";
import withTracker from "./withTracker";
import './axiosConfig.js'
import { Redirect } from 'react-router-dom';
import useTrackFirstURL from "./useTrackFirstURL";
// import { loadNewRelic } from './newrelic-loader';

// loadNewRelic();
// import NotFound from "./components/NotFound";
const NotFound = Loadable({
	loader: () => import("./components/NotFound"),
	loading: () => <Loading />,
});

// import Location from "./components/Mobile/Location";
const Location = Loadable({
	loader: () => import("./components/Mobile/Location"),
	loading: () => <Loading />,
});

// import Items from "./components/Mobile/Items";
// const Items = Loadable({
// 	loader: () => import("./components/Mobile/Items"),
// 	loading: () => <Loading />,
// });

// import Login from "./components/Mobile/Auth/Login";
const Login = Loadable({
	loader: () => import("./components/Mobile/Auth"),
	loading: () => <Loading />,
});

// import Register from "./components/Mobile/Auth/Register";
const Register = Loadable({
	loader: () => import("./components/Mobile/Auth/Register"),
	loading: () => <Loading />,
});

// import CartPage from "./components/Mobile/Cart";
const CartPage = Loadable({
	loader: () => import("./components/Mobile/Cart"),
	loading: () => <Loading />,
});

// import Account from "./components/Mobile/Account";
const Account = Loadable({
	loader: () => import("./components/Mobile/Account"),
	loading: () => <Loading />,
});

// import Explore from "./components/Mobile/Explore";
const Explore = Loadable({
	loader: () => import("./components/Mobile/Explore"),
	loading: () => <Loading />,
});

// import Addresses from "./components/Mobile/Account/Addresses";
const Addresses = Loadable({
	loader: () => import("./components/Mobile/Account/Addresses"),
	loading: () => <Loading />,
});

// import Checkout from "./components/Mobile/Checkout";
const Checkout = Loadable({
	loader: () => import("./components/Mobile/Checkout"),
	loading: () => <Loading />,
});

// import RunningOrder from "./components/Mobile/RunningOrder";
const RunningOrder = Loadable({
	loader: () => import("./components/Mobile/RunningOrder"),
	loading: () => <Loading />,
});

// import Orders from "./components/Mobile/Account/Orders";
const Orders = Loadable({
	loader: () => import("./components/Mobile/Account/Orders"),
	loading: () => <Loading />,
});

// import WalletPage from "./components/Mobile/Account/Wallet";
const WalletPage = Loadable({
	loader: () => import("./components/Mobile/Account/Wallet"),
	loading: () => <Loading />,
});
/* Delivery */
// import Delivery from "./components/Delivery";
const Delivery = Loadable({
	loader: () => import("./components/Delivery"),
	loading: () => <Loading />,
});

// import DeliveryLogin from "./components/Delivery/Login";
const DeliveryLogin = Loadable({
	loader: () => import("./components/Delivery/Login"),
	loading: () => <Loading />,
});

// import DeliveryOrders from "./components/Delivery/Orders";
const DeliveryOrders = Loadable({
	loader: () => import("./components/Delivery/Orders"),
	loading: () => <Loading />,
});

// import ViewOrder from "./components/Delivery/ViewOrder";
const ViewOrder = Loadable({
	loader: () => import("./components/Delivery/ViewOrder"),
	loading: () => <Loading />,
});

// import GeoLocationPage from "./components/Mobile/GeoLocationPage";
const GeoLocationPage = Loadable({
	loader: () => import("./components/Mobile/GeoLocationPage"),
	loading: () => <Loading />,
});

// import SingleItem from "./components/Mobile/Items/SingleItem";
// const SingleItem = Loadable({
// 	loader: () => import("./components/Mobile/Items/SingleItem"),
// 	loading: () => <Loading />,
// });

const ItemsParent = Loadable({
	loader: () => import("./components/Mobile/Items/ItemsParent"),
	loading: () => <Loading />,
});

const SingleItemParent = Loadable({
	loader: () => import("./components/Mobile/Items/SingleItemParent"),
	loading: () => <Loading />,
});

const SinglePage = Loadable({
	loader: () => import("./components/SinglePage"),
	loading: () => <Loading />,
});

const ForgotPassword = Loadable({
	loader: () => import("./components/Mobile/Auth/ForgotPassword"),
	loading: () => <Loading />,
});

const MerchantListOnCategory = Loadable({
	loader: () => import("./components/Mobile/Home/MerchantListOnCategory"),
	loading: () => <Loading />,
});

const RatingAndReview = Loadable({
	loader: () => import("./components/Mobile/Account/Orders/RatingAndReview"),
	loading: () => <Loading />,
});
const ViewStoreReviews = Loadable({
	loader: () => import("./components/Mobile/StoreReviews"),
	loading: () => <Loading />,
});

const Alerts = Loadable({
	loader: () => import("./components/Mobile/Alerts"),
	loading: () => <Loading />,
});

const FavoriteMerchantList = Loadable({
	loader: () => import("./components/Mobile/Home/FavoriteMerchants"),
	loading: () => <Loading />,
});

const LoginAsCustomer = Loadable({
	loader: () => import("./components/Mobile/Modules/LoginAsCustomer"),
	loading: () => <Loading />,
});

const ScrollToTop = () => {
	window.scrollTo(0, 0);
	return null;
};

const AppRoutes = () => {
	useTrackFirstURL();
  
	return (
		<Switch>
			{/* <Route exact strict  path="/:url*" render={props => <Redirect to={`${props.location.pathname}/`} />} /> */}
			<Route
				path="/add-api-version"
				exact
				render={() => {
					const urlParams = new URLSearchParams(window.location.search);
					const apiVersion = urlParams.get('api-version');
					if (apiVersion) {
						localStorage.setItem("api-version", apiVersion);
					}
					const slug = urlParams.get('slug');
					if (slug) {
						return <Redirect to={`/${slug}`} />;
					}
					return <Redirect to="/" />;
				}}
			/>
			<Route
				path="/remove-api-version"
				exact
				render={() => {
					localStorage.removeItem("api-version");
					return <Redirect to="/" />;
				}}
			/>
			<Route
				path="/login-by-link"
				exact
				render={() => {
					const urlParams = new URLSearchParams(window.location.search);
					const otp = urlParams.get('otp');
					let phone = urlParams.get('phone');
				
					if (otp) {
						localStorage.setItem("otp", otp);
					}
					if (phone) {
						if (!phone.startsWith('+')) {
							phone = `+${phone}`;
						}
						localStorage.setItem("phone", phone.replace(/ /g, ''));
					}
					const slug = urlParams.get('slug');
						
					if (slug) {
						return <Redirect to={`/${slug}`} />;
					}
					return <Redirect to="/" />;
				}}
			/>
			<Route path={"/"} exact component={withTracker(App)} />

			<Route path={"/search-location"} exact component={withTracker(Location)} />
			<Route path={"/my-location"} exact component={withTracker(GeoLocationPage)} />

			<Route path={"/categories/stores"} exact component={withTracker(MerchantListOnCategory)} />

			<Route path={"/explore"} exact component={withTracker(Explore)} />

			<Route path={"/login"} exact component={withTracker(Login)} />
			<Route path={"/login/forgot-password"} exact component={withTracker(ForgotPassword)} />
			<Route path={"/register"} exact component={withTracker(Register)} />

			<Route path={"/my-account"} exact component={withTracker(Account)} />
			<Route path={"/alerts"} exact component={withTracker(Alerts)} />
			<Route path={"/my-addresses"} exact component={withTracker(Addresses)} />
			<Route path={"/my-wallet"} exact component={withTracker(WalletPage)} />
			<Route path={"/my-orders"} exact component={withTracker(Orders)} />
			<Route path={"/rate-order/:id"} exact component={withTracker(RatingAndReview)} />
			<Route path={"/reviews/:slug"} exact component={withTracker(ViewStoreReviews)} />

			<Route path={"/checkout"} exact component={withTracker(Checkout)} />
			<Route path={"/running-order/:unique_order_id"} exact component={withTracker(RunningOrder)} />

			<Route path={"/cart"} exact component={withTracker(CartPage)} />

			<Route path={"/pages/:slug"} exact component={withTracker(SinglePage)} />
			<Route path={"/my-favorite-stores"} exact component={withTracker(FavoriteMerchantList)} />
			{/* Delivery Routes */}
			<Route path={"/delivery"} exact component={Delivery} />
			<Route path={"/delivery/login"} exact component={DeliveryLogin} />
			<Route path={"/delivery/orders"} exact component={DeliveryOrders} />
			<Route path={"/delivery/orders/:unique_order_id"} exact component={ViewOrder} />
			<Route path={"/delivery/completed-orders"} exact component={Delivery} />
			{/* Common Routes */}
			{/* Admin Login as Customer Module Routes */}
			<Route path={"/auth/login-as-customer/:id?"} exact component={LoginAsCustomer} />
			{/* END Admin Login as Customer Module Routes */}

			{/* <Route path={"/stores/:merchant"} exact component={withTracker(Items)} /> */}
			<Route path={"/:merchant"} exact component={withTracker(ItemsParent)} />
			{/* <Route path={"/stores/:merchant/:id"} exact component={withTracker(SingleItem)} /> */}
			<Route path={"/:merchant/:id"} exact component={withTracker(SingleItemParent)} />
			<Route component={NotFound} />
		</Switch>
	);
  };

ReactDOM.render(
	<Root>
		<BrowserRouter>
			<React.Fragment>
				<Route component={ScrollToTop} />
				<AppRoutes />
			</React.Fragment>
		</BrowserRouter>
	</Root>,
	document.getElementById("root")
);
